import { createSlice } from '@reduxjs/toolkit';

export interface IPartnerOrg {
  org_id: number;
  org_name: string;
}

export interface IInitState {
  partnerOrgs: IPartnerOrg[];
}

const initialState: IInitState = {
  partnerOrgs: [],
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setPartnerOrgs: (state, action) => {
      state.partnerOrgs = action.payload;
    },
  },
});

export const { setPartnerOrgs } = commonSlice.actions;
export default commonSlice.reducer;
